export enum SearchItemType {
    Song = 1,
    Album = 2,
    Artist = 3
}